import { CREATE } from '../actions/actionTypes';


const orderReducer = (cOrders = [], action) => {
    console.log('q')
  switch (action.type) {
    case CREATE:
      return [...cOrders, action.payload];
    default:
      return cOrders;
  }
};

export default orderReducer;